module.exports = __webpack_public_path__ + "static/media/blogger.a537caa0.svg";